// extracted by mini-css-extract-plugin
export var label = "Label-module--label--2nDUs";
export var optional = "Label-module--optional--2nm8d";
export var show = "Label-module--show--3bOHV";
export var showFadeInDown = "Label-module--show-fade-in-down--cTyQ3";
export var showFadeInUp = "Label-module--show-fade-in-up--1wHGA";
export var hideFadeOut = "Label-module--hide-fade-out--4kQPR";